export default __webpack_public_path__ + "static/media/street-map-image.3caffa8c.PNG";